import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';
import {Body} from 'shells/typography/body';

type Props = {
    title: string;
    subtitle: string | null | undefined;
    icon: React.ComponentType<any>;
    onClick: () => void;
};

export function AutomationCard(props: Props) {
    return (
        // @ts-expect-error
        <TwoLineButtonCard borderColor={colors.dotcomTeal} onClick={props.onClick}>
            <TwoLine
                icon={props.icon}
                iconSize={24}
                iconColor={colors.grey}
                topRow={props.title}
                bottomRow={props.subtitle}
                isLargeWithSmallBottomRow={true}
                shouldCenterSingleLine={true}
            />
            <Body color='blue'>Edit</Body>
        </TwoLineButtonCard>
    );
}
